<div class="vox-table verification-data-table">
    <table>
        <thead>
            <tr>
                <td translate>
                    <div class="label-container">
                        <span translate>company.dids.verification-data.table.thead.label.label</span>
                    </div>
                </td>
                <td translate>
                    <div class="label-container">
                        <span translate>company.dids.verification-data.table.thead.type.label</span>
                    </div>
                </td>
                <td translate>
                    <div class="label-container">
                        <span translate>company.dids.verification-data.table.thead.first-name.label</span>
                    </div>
                </td>
                <td translate>
                    <div class="label-container">
                        <span translate>company.dids.verification-data.table.thead.last-name.label</span>
                    </div>
                </td>
                <td translate>
                    <div class="label-container">
                        <span translate>company.dids.verification-data.table.thead.company.label</span>
                    </div>
                </td>
                <td translate>
                    <div class="label-container">
                        <span translate>company.dids.verification-data.table.thead.email.label</span>
                    </div>
                </td>
                <td translate>company.dids.verification-data.table.thead.country.label</td>
                <td translate>company.dids.verification-data.table.thead.address.label</td>
                <td translate>company.dids.verification-data.table.thead.documents.label</td>
                <td translate>company.dids.verification-data.table.thead.actions.label</td>
            </tr>
        </thead>
        <tbody *ngIf="!loading">
            <ng-container *ngFor="let data of verificationDataList">
                <tr *ngIf="data._isDeleting">
                    <td colspan="10">
                        <ngx-skeleton-loader></ngx-skeleton-loader>
                    </td>
                </tr>
                <tr *ngIf="!data._isDeleting">
                    <td>
                        <span *ngIf="data.label">{{data.label}}</span>
                        <span *ngIf="!data.label">-</span>
                    </td>
                    <td>
                        <span *ngIf="data.type">{{data.type}}</span>
                        <span *ngIf="!data.type">-</span>
                    </td>
                    <td>
                        <span *ngIf="data.first_name">{{data.first_name}}</span>
                        <span *ngIf="!data.first_name">-</span>
                    </td>
                    <td>
                        <span *ngIf="data.last_name">{{data.last_name}}</span>
                        <span *ngIf="!data.last_name">-</span>
                    </td>
                    <td>
                        <span *ngIf="data.company_name">{{data.company_name}}</span>
                        <span *ngIf="!data.company_name">-</span>
                    </td>
                    <td>
                        <span *ngIf="data.email">{{data.email}}</span>
                        <span *ngIf="!data.email">-</span>
                    </td>
                    <td>{{data.country_code}}</td>
                    <td>
                        <span *ngIf="data.address.street_name && data.address.street_number">
                            {{data.address.street_name}}, {{data.address.street_number}}</span>
                        <span *ngIf="!data.address.street_name && !data.address.street_number">-</span>
                    </td>
                    <td>
                        <i *ngIf="data.documents.length > 0" class="icon-small-check-circle"></i>
                        <span *ngIf="data.documents.length === 0">-</span>
                    </td>
                    <td>
                        <button class="vox-btn btn-warning"
                            [ngbTooltip]="'company.dids.verification-data.table.tooltip-details' | translate"
                            (click)="openVDDetailsPopup(data)"><i class="icon-small-info"></i></button>
                        <!-- TODO: remove hide when we enable to edit vd -->
                        <button hidden class="vox-btn btn-warning"><i class="icon-small-edit"></i></button>
                        <!-- TODO: delete this functionality -->
                        <button class="d-none vox-btn btn-danger" [disabled]="company.readOnly"
                            (click)="deleteVerificationData(data)"><i class="icon-small-delete"></i></button>
                    </td>
                </tr>
            </ng-container>
        </tbody>
        <tbody *ngIf="loading">
            <tr *ngFor="let i of [1,2,3,4]">
                <td colspan="10">
                    <ngx-skeleton-loader></ngx-skeleton-loader>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="!loading && verificationDataList.length === 0">
            <tr>
                <td colspan="10" translate style="text-align: center;">company.dids.verification-data.empty</td>
            </tr>
        </tbody>
    </table>
</div>